<template>
  <div class="collect-fee-2" data-test="sf-2">
    <div class="main">
      <div class="htop" :class="{ stp7: (order.sourceType == 7 || order.sourceType == 10), 'sports':companyInfo.companyProduct.productPackage==3 }" v-if="order">
        <!-- 电子钱包预存和储值卡充值，不允许欠交 -->
        <template v-if="(order.sourceType == 7 || order.sourceType == 10)">
          <div class="stp71">订单金额</div>
          <div class="stp72">￥{{ order.orderReceivableMoney | formatNumber }}</div>
        </template>
        <template v-else>
          <div class="ht1">
            <div class="ht11">实收总额</div>
            <div class="ht12" v-if="showFenBtn" @click="gotoFen">
              <van-icon name="column" style="margin-right: 2px;color: #fff;" />分摊明细
            </div>
          </div>
          <div class="ht2">
            <div>￥</div>
            <van-field
              :class="{ placeh: allNum.length == 0 }"
              v-model="allNum"
              type="number"
              placeholder="请输入实收总额"
              :formatter="app.tool.format2MaxWrap(order.oweMoney)"
              @input="rmInput"
            />
          </div>
          <div class="ht3" v-if="order">
            <div class="ht31">
              <template v-if="order.hasPay == 0"> 应收金额</template>
              <template v-else-if="order.hasPay == 1"> 应补交金额</template>
              ：¥{{ order.oweMoney | formatNumber }}
            </div>
            <div class="ht32 van-hairline--left" v-if="ownNum">欠交：￥{{ ownNum | formatNumber }}</div>
          </div>
        </template>
      </div>
      <van-cell
        v-if="ownNum"
        title="下次补交日期"
        :is-link="!nextPayTime"
        @click="chooseNextDate()"
      >
        <template>
          <div v-if="nextPayTime">
            <div class="fepl van-ellipsis">
              <div>{{ nextPayTime | filterDate }}</div>
              <div class="ricon" @click.stop="nextPayTime = ''">
                <van-icon name="clear" color="var(--g6)" />
              </div>
            </div>
          </div>
          <div v-else style="color: var(--g5)">请选择</div>
        </template>
      </van-cell>

      <van-radio-group v-model="accountId" class="group">
        <!-- 是“电子钱包”，则隐藏电子钱包支付（即电子钱包预存，不支持电子钱包支付） -->
        <template v-if="walletObj && order.sourceType != 7">
          <div class="ptil">电子钱包支付</div>
          <div class="pm-wrap">
            <div class="pm" @click.stop="clickWallet">
              <div class="r">
                <div class="pmc">
                  <div class="tytext">{{ walletObj.campusName }}</div>
                  <!-- <van-checkbox
                    v-if="useWalletNum > 0"
                    :value="useWalletPay"
                    size="calc(var(--w) * 24)"
                  />
                  <van-checkbox
                    v-else
                    :value="useWalletPay"
                    :disabled="!walletObj.money || allNum == 0 || (useWalletNum == 0 && otherNum == 0)"
                    size="calc(var(--w) * 24)"
                  /> -->
                  <van-checkbox
                    :value="useWalletPay"
                    :disabled="!walletObj.money || allNum == 0 || (useWalletNum == 0 && otherNum == 0)"
                  ></van-checkbox>
                </div>
                <div class="desc">可用余额：<span class="red">￥{{ totalAvailableMoney | formatNumber }}</span>
                  <van-icon
                    name="question-o"
                    size="var(--fs-md)"
                    style="vertical-align: text-top"
                    @click.stop="()=>{showWalletDetailDialog = true}"
                  />
                </div>
                <div class="desc">支付金额：¥{{ useWalletNum | formatNumber }}&nbsp;<span style="color: var(--tlc)" @click.stop="changeEWallet">修改</span></div>
              </div>
            </div>
          </div>
        </template>

        <!-- 使用储值卡支付：是“电子钱包、储值卡”，则隐藏储值卡支付（即电子钱包预存和储值卡充值，不支持储值卡支付） -->
        <template v-if="order && order.sourceType !== 7 && order.sourceType !== 10">
          <div class="ptil">储值卡支付</div>
          <div class="pm-wrap">
            <div class="pm van-hairline--bottom" @click.stop="clickScard(scard)" v-for="scard in storedCardAccountList" :key="scard.id">
              <div class="r">
                <div class="pmc">
                  <div class="tytext">{{ scard.storedCardAccountName }}<span class="tag" v-if="scard.isOther">代付</span><span class="tag is-expire" v-if="scard.status==2">已过期</span></div>
                  <!-- <van-checkbox
                    v-if="scard.money && scard.money > 0"
                    :value="scard.isChecked"
                    size="calc(var(--w) * 24)"
                  />
                  <van-checkbox
                    v-else
                    :value="scard.isChecked"
                    :disabled="otherNum == 0"
                    size="calc(var(--w) * 24)"
                  /> -->
                  <van-checkbox
                    :value="scard.isChecked"
                    :disabled="scard.status == 2 || scard.allTotalMoney == 0 || allNum == 0 || (!scard.money && otherNum == 0)"
                  ></van-checkbox>
                </div>
                <div class="desc">
                  <span v-if="scard.storedCardName" style="margin-right:calc(var(--w) * 12)">持卡人：{{ scard.storedCardName }}</span>
                  可用余额：<span class="red">￥{{ scard.allTotalMoney | formatNumber }}</span>
                  <van-icon
                    name="question-o"
                    size="var(--fs-md)"
                    style="vertical-align: text-top"
                    @click.stop="toShowStoredCardDetail(scard)"
                  />
                </div>
                <div class="desc">支付金额：￥{{ scard.money | formatNumber }}&nbsp;<span style="color: var(--tlc)" @click.stop="changeStoredCard(scard)">修改</span></div>
              </div>
            </div>
            <div class="pm-empty" v-if="storedCardAccountList.length == 0">当前学员没有可用的储值卡。</div>
          </div>
          <div class="pm-tips" v-if="!hasOtherVerifyStoredCard">如需使用其他未绑定储值卡，点此进入<span style="color:var(--c1);" @click.stop="verifyStoredCard">其他储值卡代付</span></div>
        </template>

        <div class="ptil flex-between">
          <div>线上支付-收费管家<span class="recommend">推荐</span></div>
          <div
            v-if="!merchantInfo.isOpenSfgj && !app.yunxiaoApp.isIosTestUser"
            class="btns"
            :class="{ 'is-admin': app.teacher.user.admin }"
            @click="toOpenSfgj"
          >
            立即开通
          </div>
          <div
            v-else-if="!merchantInfo.hasMch && !app.yunxiaoApp.isIosTestUser"
            class="btns"
            :class="{ 'is-admin': app.teacher.user.admin }"
            @click="toSetMch"
          >
            设置线上收款商户
          </div>
        </div>
        <div class="pm-wrap" v-if="!app.yunxiaoApp.isIosTestUser">
          <div
            class="pm van-hairline--bottom"
            v-for="item in accounts.onlineAccount"
            :key="item.id"
            @click.stop="changeOnlineAccount(item)"
          >
            <div class="icon icon1"></div>
            <div class="r">
              <div class="pmc">
                <div class="tytext">付款码收款</div>
                <div class="tynum" v-if="accountId == item.id && order.sourceType != 7">
                  ¥{{ otherNum | formatNumber }}
                </div>
                <van-radio :disabled="!hasMerchant || otherNum == 0" :name="item.id" />
              </div>
              <div class="desc">生成付款码，家长用微信、支付宝扫码支付</div>
            </div>
          </div>

          <div class="pm" @click.stop="changeOnlineAccount(sendPayObj)" v-if="order">
            <div class="icon icon2"></div>
            <div class="r">
              <div class="pmc">
                <div class="tytext">推送给家长收款</div>
                <div class="tynum" v-if="accountId == sendPayObj.id && order.sourceType != 7">
                  ¥{{ otherNum | formatNumber }}
                </div>
                <van-radio :disabled="!hasMerchant || otherNum == 0" :name="sendPayObj.id" />
              </div>
              <div class="desc" v-if="order.hasPay == 1">家长将收到通知提醒，可随时进行支付</div>
              <div class="desc" v-else>家长将收到通知提醒，可3天内进行支付</div>
            </div>
          </div>
        </div>

        <div class="tip-wrap" v-if="accountId == 'x_send'">
          <div class="tip">如家长未绑定账号，将无法接收到提醒通知。</div>
          <div class="tip-link" @click="gotoLink">通知家长绑定</div>
        </div>

        <div class="ptil flex-between">线下收款</div>
        <div class="pm-wrap" v-if="!hasCustom">
          <div
            class="pm van-hairline--bottom"
            v-for="item in accounts.offlineAccount"
            :key="item.id"
            @click.stop="changeAccount(accounts.offlineAccount[0])"
          >
            <div class="icon icon3"></div>
            <div class="r">
              <div class="pmc">
                <div class="tytext">线下收款</div>
                <div class="tynum" v-if="accountId == item.id && order.sourceType != 7">
                  ¥{{ otherNum | formatNumber }}
                </div>
                <van-radio :disabled="otherNum == 0" :name="item.id" />
              </div>
              <div class="desc">通过其他方式收款，进行费用记账</div>
              <div class="desc" v-if="accountType == 2" @click.stop="chooseChargeDate">
                收费日期：{{ chargeDate }} &nbsp;&nbsp;<span style="color: var(--tlc)" v-if="app.permission.op('fee_charge_edit_time')">修改</span>
              </div>
            </div>
          </div>
        </div>
        <div class="pm-wrap" v-else>
          <div
            class="pm van-hairline--bottom"
            v-for="item in accounts.offlineAccount"
            :key="item.id"
            @click.stop="changeCustomAccount(accounts.offlineAccount[0])"
          >
            <div class="icon icon3"></div>
            <div class="r">
              <div class="pmc">
                <div class="tytext">线下收款</div>
                <van-radio :disabled="otherNum == 0" :name="item.id" />
              </div>
            </div>
          </div>
        </div>
      </van-radio-group>
    </div>
    <page-footer-btn multipleBtns>
      <van-button square round block type="primary" @click="submit" data-test="sf-2-btn-confirm">
        确认收款<span v-if="allNum.length > 0">：￥{{ allNum | formatNumber }}</span>
      </van-button>
    </page-footer-btn>

    <!-- 修改线下收款弹窗 -->
    <custom-account ref="customAccount"></custom-account>
    <!-- 学员电子钱包明细弹窗 -->
    <van-dialog v-model="showWalletDetailDialog" confirmButtonText="我知道了">
      <div class="student-wallet-detail-dialog" v-if="walletObj">
        <div>钱包余额：￥{{walletObj.money | formatNumber}}</div>
        <div>
          <van-popover
            v-model="showWalletDetailPopup"
            class="popover-wrap"
            theme="dark"
            trigger="click"
            placement="top-start"
            :offset="[-8, 4]"
          >
            <div style="width: 85vw">
              待付款订单或者补交已使用电子钱包进行支付，但尚未完成支付，会导致这部分金额被冻结。完成支付或者取消订单可解除冻结。
            </div>
            <template #reference>
              冻结金额
              <van-icon name="question-o" style="vertical-align: text-top;" />：￥{{totalFrozenMoney | formatNumber}}
            </template>
          </van-popover>
        </div>
      </div>
    </van-dialog>
    <!-- 修改电子钱包及储值卡金额弹窗 -->
    <eWallet-edit-popup ref="eWalletEdit"/>
    <!-- 储值卡明细弹窗 -->
    <van-dialog v-model="showStoredCardDetailDialog" confirmButtonText="我知道了">
      <div class="student-wallet-detail-dialog" v-if="currentStoredCardDetail">
        <div>本金：￥{{currentStoredCardDetail.principalTotalMoney | formatNumber}}</div>
        <div>赠送：￥{{currentStoredCardDetail.giveTotalMoney | formatNumber}}</div>
      </div>
    </van-dialog>
    <!-- 储值卡绑定弹窗 -->
    <storedCardVerifyPopup ref="storedCardVerifyPopupRefs"/>
  </div>
</template>

<script>
import toOpenSfgj from '../wallet/to-open-sfgj-mixin';
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
import customAccount from './popup/custom-account-popup.vue';
import eWalletEditPopup from './popup/e-wallet-edit-popup.vue';
import storedCardVerifyPopup from './popup/stored-card-verify-popup.vue';

export default {
  name: 'collect-fee-2',
  mixins: [toOpenSfgj],
  data() {
    let openWalleted =
      app.tool
        .safeReadObjProp(app.teacher.user, 'companyInfoVo.companyAppOpenList')
        .indexOf('WALLET') > -1;
    return {
      pageTitle: '收款结算',
      // 当前机构与收费校区开通使用收费管家情况
      merchantInfo: {
        isOpenSfgj: false,
        hasMch: false,
      },
      // 写死的发送给家长的对象
      sendPayObj: {
        id: 'x_send',
        comeFrom: 'x_send',
      },
      hasCustom: false,
      // 收款方式id:1线上支付，'x_send'线上推送给家长付款，2线下其他方式收款
      accountType: '',
      accountId: '',
      accounts: {},
      // 收费日期
      cdate: new Date(),
      // 订单id
      orderId: this.$route.params.id,
      // 隐藏下个页面的继续收费按钮，转课过来需要隐藏
      hidegotoSf: this.$route.query.hidegotoSf,
      // 订单信息
      order: null,

      // 20211018 实收总额
      allNum: '',
      // 是否开通电子钱包
      openWalleted: openWalleted,
      // 学员在当前订单所属校区的电子钱包信息
      walletObj: null,
      // 是否使用电子钱包支付
      useWalletPay: false,
      // 分摊明细信息,用于只保留有欠费的项目明细
      rpitems: [],
      // 是否已分摊
      isrp: false,
      // 下次补交日期
      nextPayTime: '',
      // 自定义账户
      paymentRecordDetailList: [],
      showWalletDetailDialog: false,
      showWalletDetailPopup: false,
      useWalletNum: 0,
      // 学员储值卡总账户详情
      storedCardAccountList: [],
      showStoredCardDetailDialog: false,
      currentStoredCardDetail: null
    };
  },
  computed: {
    ...Vuex.mapState(['userInfo', 'companyInfo']),
    // 这笔订单总的电子钱包可用金额=钱包可用余额+上次下单选择的电子钱包金额（即这笔单上次的冻结金额）
    totalAvailableMoney() {
      let total = this.walletObj.availableMoney || 0;
      this.walletObj.walletOrderFrozenList.forEach(it => { // 从冻结记录里找到相同的订单号，获取上次的冻结金额
        if (it.orderId == this.orderId) {
          total = total + Number(it.money); // 得到这笔单总的可用金额=钱包可用余额+上次的冻结金额
        }
      });
      return total;
    },
    totalFrozenMoney() { // 冻结金额=冻结金额-上次下单选择的电子钱包金额（即这笔单上次的冻结金额）
      let total = this.walletObj.frozenMoney || 0;
      this.walletObj.walletOrderFrozenList.forEach(it => { // 从冻结记录里找到相同的订单号，获取上次的冻结金额
        if (it.orderId == this.orderId) {
          total = total - Number(it.money); // 得到这笔单总的可用金额=冻结金额-上次的冻结金额
        }
      });
      return total;
    },
    // 电子钱包默认能支付的金额
    canuseWalletNum() {
      let num = 0;
      let sub = Number(((this.allNum * 1000 - this.getTotalStoredCardMoney() * 1000) / 1000).toFixed(2));
      if (sub > this.totalAvailableMoney) {
        num = this.totalAvailableMoney;
      } else {
        num = sub;
      }
      return num;
    },
    // 是否使用了储值卡支付
    useStoredCardPay() {
      const list = this.storedCardAccountList.filter(item=> item.isChecked);
      return list.length > 0;
    },
    // 是否展示代付按钮
    hasOtherVerifyStoredCard() {
      const list = this.storedCardAccountList.filter(item=> item.isOther);
      return list.length > 0;
    },
    // 其它收款方式应收金额
    otherNum() {
      let num = app.tool.formatFloat(this.allNum - this.useWalletNum - this.getTotalStoredCardMoney(), 2);
      if (num == 0) {
        this.accountId = '';
        this.accountType = '';
      }
      return num;
    },
    // 欠交金额
    ownNum() {
      if (this.order && this.allNum.length > 0) {
        return app.tool.formatFloat(this.order.oweMoney - this.allNum, 2);
      } else {
        return 0;
      }
    },
    // 是否需要显示分摊按钮
    showFenBtn() {
      let bool = false;
      if (this.allNum > 0 && this.ownNum > 0) {
        if (this.rpitems.length > 1) {
          bool = true;
        }
      }
      return bool;
    },
    // 收费日期
    chargeDate() {
      return app.tool.date.formatDatetime(this.cdate, 'yyyy-MM-dd');
    },
    // 是否开通了收银管家
    hasMerchant() {
      return this.merchantInfo.isOpenSfgj && this.merchantInfo.hasMch;
    },
  },
  filters: {
    filterDate(v) {
      return v && new Date(v) ? app.tool.date.filterDate(new Date(v)) : '请选择';
    },
  },
  methods: {
    // 已选的储值卡的总额
    getTotalStoredCardMoney() {
      const list = this.storedCardAccountList.filter(item => item.money > 0);
      const total = list.reduce((pre, cur) => {
        return pre + Number(cur.money || 0);
      }, 0);
      return total;
    },
    // 1、储值卡是否能点击
    // 2、储值卡点击之后默认金额是多少：实收总额-电子钱包-已选的储值卡的总额
    // 储值卡支付默认能支付的金额
    getStoredCardDefaultNum(item) {
      let num = 0;
      let sub = Number(((this.allNum * 1000 - this.useWalletNum * 1000 - this.getTotalStoredCardMoney() * 1000) / 1000).toFixed(2));
      if (item.allTotalMoney > sub) {
        num = sub;
      } else {
        num = item.allTotalMoney;
      }
      return num;
    },
    // 跳转到分摊页
    async gotoFen() {
      let fp = new Promise((resolve, reject) => {
        app.router.push(
          `/fen?totalMoney=${this.allNum}`,
          route => {
            route.meta._resolve = resolve;
            route.meta._reject = reject;
            route.meta.hasPay = this.order.hasPay;
            route.meta.list = app.tool.clone(this.rpitems);
          },
          err => {
            console.log(err);
          }
        );
      });
      this.rpitems = await fp;
      this.isrp = true;
      console.log(this.rpitems);
    },
    rmInput() {
      this.isrp = false;
      this.rpitems.forEach(item => (item.money = ''));
    },
    // 获取收款方式
    async getAccList() {
      let res = await this.$api.getPaymentAccountList({
        campusId: this.order.campusId,
      });
      this.accounts = res.data;
      if (res.data.offlineCustomAccount) {
        this.paymentRecordDetailList = res.data.offlineCustomAccount.map(item => {
          return {
            name: item.name,
            paymentAccountCustomId: item.id,
            money: '',
            checked: false,
          };
        });
      }
      this.hasCustom = res.data.hasCustom;
    },
    // 获取订单信息
    async getOrderInfo() {
      let ret = await this.$api.orderInfoGet({
        orderInfoId: this.orderId,
      });
      ret.data.orderItems.forEach(item => {
        if (item.oweFee == 1) {
          this.rpitems.push({
            ...item,
            money: '',
            orderItemId: item.id,
          });
        }
      });
      this.order = ret.data;
      this.allNum = this.order.oweMoney;

      await this.getStudentWalletInfos();
    },
    // 查询学员各校区钱包余额
    async getStudentWalletInfos() {
      if (this.openWalleted && this.order.studentId) {
        let res = await this.$api.getStudentWalletDetail({
          id: this.order.studentId,
          queryFrozenRecord: true // 是否查询冻结记录
        });
        res.data.campusWalletList.forEach(item => {
          if (item.campusId == this.order.campusId) {
            this.walletObj = item;
          }
        });
      }
      // 查询学员储值卡总账户详情
      if (this.order.studentId) {
        let res = await this.$api.queryStudentStoredCardAccount({
          studentId: this.order.studentId
        });
        this.storedCardAccountList = res.data.map(v=> {
          return {
            ...v,
            isChecked: false,
            money: 0
          }
        });
      }
    },
    async toSetMch() {
      if (app.permission.op('campus_merchant_list')) {
        // await vant.Dialog.confirm({
        //   title: '',
        //   message: `当前收费校区还未设置线上收款商户，无法进行线上收款，请选择“线下收款”或“设置线上收款商户”`,
        //   confirmButtonText: '设置线上收款商户',
        // });
        this.$router.push(`/sf/set/channel?active=1&campusId=${this.order.campusId}`);
      } else {
        vant.Toast('没有操作权限，请联系机构超级管理员');
      }
    },
    // 查询是否开通了收银管家
    async getMerchant() {
      let odr = this.order;
      if (odr && odr.campusId) {
        let ret = await this.$api.checkCampusMerchant({
          campusId: odr.campusId,
        });
        this.merchantInfo = ret.data;
      }
    },
    async render() {
      this.showLoading();
      await this.getOrderInfo();
      await this.getAccList();
      // await Promise.all([this.getAccList(), this.getOrderInfo()]);
      await this.getMerchant();

      this.$toast.clear();
    },
    // 电子钱包选择
    clickWallet() {
      // if (this.walletObj.money > 0) {
      //   if (this.useWalletNum == 0 && this.otherNum == 0) {
      //     return;
      //   }
        if (!this.walletObj.money || this.allNum == 0 || (this.useWalletNum == 0 && this.otherNum == 0)) {
          return;
        }
        this.useWalletPay = !this.useWalletPay;
        this.useWalletNum = this.useWalletPay ? this.canuseWalletNum : 0;
      // }
    },
    // 电子钱包修改
    changeEWallet() {
      let sub = Number(((this.allNum * 1000 - this.getTotalStoredCardMoney() * 1000) / 1000).toFixed(2));
      this.$refs.eWalletEdit.open({
        useNum: this.useWalletNum, // 使用的电子钱包金额
        remainMoney: sub, // 剩余实收总额
        totalAvailableMoney: this.totalAvailableMoney, //电子钱包总的可用金额
        title: '电子钱包支付'
      }).then(({ updateMoney })=>{
        this.useWalletPay = updateMoney>0? true:false;
        this.useWalletNum = updateMoney>0? updateMoney:0;
      })
    },
    // 储值卡选择
    clickScard(scard) {
      if (scard.status == 2 || scard.allTotalMoney == 0 || this.allNum == 0 || (!scard.money && this.otherNum == 0)) {
        return;
      }
      // if (scard.isChecked || (!scard.isChecked && this.otherNum > 0)) {
        this.$set(scard, 'isChecked', !scard.isChecked);
        scard.money = scard.isChecked ? this.getStoredCardDefaultNum(scard) : 0;
      // }
    },
    // 储值卡修改
    changeStoredCard(item) {
      let sub = Number(((this.allNum * 1000 - this.useWalletNum * 1000 - this.getTotalStoredCardMoney() * 1000 + item.money * 1000) / 1000).toFixed(2));
      this.$refs.eWalletEdit.open({
        useNum: item.money, // 使用的金额
        remainMoney: sub, // 剩余实收总额
        totalAvailableMoney: item.allTotalMoney, //可用金额
        title: '储值卡支付'
      }).then(({ updateMoney })=>{
        item.isChecked = updateMoney>0? true:false;
        item.money = updateMoney>0? updateMoney:0;
      })
    },
    // 绑定储值卡
    verifyStoredCard() {
      this.$refs.storedCardVerifyPopupRefs.open({
        list: this.storedCardAccountList
      }).then((res)=>{
        console.log(res.data);
        this.storedCardAccountList = this.storedCardAccountList.concat(res.data);
      })
    },
    // 选择线上支付方式
    changeOnlineAccount(item) {
      if (!this.hasMerchant) {
        vant.Toast('未开通线上支付');
      } else {
        this.changeAccount(item);
      }
    },
    changeCustomAccount(item) {
      if (this.otherNum == 0) {
        return;
      }
      this.$refs.customAccount
        .open({
          cdate: this.cdate,
          paymentRecordDetailList: this.paymentRecordDetailList,
          oweMoney: this.otherNum,
        })
        .then(({ paymentRecordDetailList, cdate }) => {
          this.cdate = cdate;
          this.paymentRecordDetailList = paymentRecordDetailList;
          this.accountType = item.comeFrom;
          this.accountId = item.id;
          this.submit();
        })
        .catch(() => {
          this.accountType = '';
          this.accountId = '';
        });
    },
    changeAccount(item) {
      if (this.otherNum) {
        this.accountType = item.comeFrom;
        this.accountId = item.id;
      }
    },
    gotoLink() {
      app.x3.picker.notifyBindAccount();
    },
    // 选择下次补交日期
    async chooseNextDate() {
      let res = await app.x3.picker.calendar({
        defaultDate: this.nextPayTime ? new Date(this.nextPayTime) : new Date(),
        maxDate: new Date(2030, 12, 31),
      });
      this.nextPayTime = res.getTime();
    },
    // 设置收费日期
    async chooseChargeDate() {
      if(app.permission.op('fee_charge_edit_time')) {
        let res = await app.x3.picker.calendar({
          defaultDate: this.cdate,
          minDate: new Date(2020, 1, 1),
          maxDate: new Date(),
        });
        this.cdate = res;
      }
    },
    // 组装参数
    jointParams() {
      // 组装支付参数
      let plist = [];
      if (this.allNum > 0) {
        if (this.useWalletPay) {
          plist.push({
            money: this.useWalletNum,
            payType: 0, // 支付类型: 0钱包支付, 1线上支付, 2线下收款, 3储值卡支付	
          });
        }
        const sclist = this.storedCardAccountList.filter(item => item.isChecked);
        if (sclist.length > 0) {
          sclist.forEach(v=> {
            let tempObj = {
              money: v.money,
              payType: 3,
              payTypeBizId: v.id,
            }
            if (v.isOther) {
              tempObj = {
                ...tempObj,
                verifyCode: v.verifyCode, // 验证代码 目前用于未绑定储值卡支付校验	
                verifyPhone: v.verifyPhone // 验证手机号 目前用于未绑定储值卡支付校验	
              }
            }
            plist.push(tempObj);
          })
        }
        if (this.accountType == 1) {
          plist.push({
            money: this.otherNum,
            payType: this.accountType,
            paymentAccountId: this.accountId,
          });
        }
        if (this.accountType == 'x_send') {
          let obj = this.accounts.onlineAccount[0];
          plist.push({
            money: this.otherNum,
            payType: obj.comeFrom,
            paymentAccountId: obj.id,
          });
        }
        if (this.accountType == 2) {
          plist.push({
            chargeDate: this.chargeDate,
            money: this.otherNum,
            payType: this.accountType,
            paymentAccountId: this.accountId,
            paymentRecordDetailList: this.paymentRecordDetailList.filter(item => item.checked),
          });
        }
      }

      // 项目明细分摊金额集合
      let rpitemsParams = [];
      if (this.showFenBtn) {
        rpitemsParams = this.rpitems.map(item => {
          return {
            money: item.money || 0,
            orderItemId: item.id,
          };
        });
      } else {
        if (this.allNum == 0) {
          rpitemsParams = this.rpitems.map(item => {
            return {
              money: 0,
              orderItemId: item.id,
            };
          });
        } else if (this.allNum == this.order.oweMoney) {
          rpitemsParams = this.rpitems.map(item => {
            return {
              money: item.oweMoney,
              orderItemId: item.id,
            };
          });
        } else if (this.rpitems.length == 1) {
          rpitemsParams = this.rpitems.map(item => {
            return {
              money: this.allNum,
              orderItemId: item.id,
            };
          });
        }
      }

      return {
        beforeMoney: this.order.payFact,
        money: Number(this.allNum),
        orderId: this.orderId,
        parentChildId: '',
        paymentRecordList: plist,
        receivePaymentItems: rpitemsParams,
        nextPayTime: this.nextPayTime,
      };
    },
    // 表单检查
    check() {
      let msg = '';
      if (this.allNum == '') {
        msg = '请填写实收总额';
      } else if (this.allNum == 0 && this.order.hasPay == 1) {
        msg = '补交金额需要大于0';
      } else {
        // bool1: 没有使用钱包 没有使用储值卡支付 的情况下没有勾选收款方式
        // bool2: 使用钱包/使用储值卡支付 的情况下没有勾选收款方式
        // let bool1 = !this.useWalletPay && !this.useStoredCardPay && !this.accountType && this.allNum > 0,
        //   bool2 = this.useWalletPay && !this.accountType && this.allNum != this.useWalletNum;
        // if (bool1 || bool2) {
        //   msg = '请选择收款方式';
        // }
        let sum = Number(((this.useWalletNum * 1000 + this.getTotalStoredCardMoney() * 1000) / 1000).toFixed(2));
        let bool1 = !this.useWalletPay && !this.useStoredCardPay && !this.accountType && this.allNum > 0,
          bool2 =  !this.accountType && this.allNum != sum;
        if (bool1 || bool2) {
          msg = '请选择收款方式';
        }
      }
      if (msg) {
        vant.Toast(msg);
      }
      return !msg;
    },
    // 检查是否分摊
    async checkFen() {
      if (this.showFenBtn && !this.isrp) {
        try {
          await vant.Dialog.confirm({
            title: '',
            message: `当前有欠交，需要按项目进行金额分摊。`,
            confirmButtonText: '去分摊',
          });
          this.gotoFen();
        } catch (error) {}
        return false;
      }
      return true;
    },
    async submit() {
      if (!this.check()) {
        return;
      }

      if (!(await this.checkFen())) {
        return;
      }

      let apiParams = this.jointParams();

      if (this.accountType == 'x_send') {
        this.showLoading();
        let ret = await this.$api.sendOrderInfoMsg(apiParams);
        console.log('...........');
        this.$toast.clear();
        let url = `/pay?accountId=${this.accountId}&orderId=${this.orderId}&paymentGroupId=${ret.data.paymentGroupDto.id}&step=2&preHasPay=${this.order.hasPay}`;
        this.$router.push(url);
      } else {
        this.showLoading();
        let ret = await this.$api.proportionPayment(apiParams);
        this.$toast.clear();

        if (ret.code == 200) {
          let url = `/pay?accountId=${this.accountId}&orderId=${this.orderId}&preHasPay=${this.order.hasPay}`;
  
          // 只在产生支付记录时传递支付id；有可能是0元首付，此时不会产生支付记录；
          if (ret.data && ret.data.paymentGroupDto && ret.data.paymentGroupDto.money > 0) {
            url += `&paymentGroupId=${ret.data.paymentGroupDto.id}`;
          }
  
          let { btnText, routerName } = this.$vxRoute.query || {};
          // 设置成功页面跳转按钮文案
          if (btnText) {
            url += '&btnText=' + btnText;
          }
          // 设置成功页面跳转按钮路由名
          if (routerName) {
            url += '&routerName=' + routerName;
          }
          if (this.hidegotoSf) {
            url += '&hidegotoSf=1';
          }
          // 订单来源：0:商城，1:前台收费，2:老生录入，3:退费，4:转课转入收费，5:转课转出退费，6:商城会员积分-物品，7:钱包预存，9:预存退费，10:储值卡充值
          if (this.order.sourceType === 7) {
            url += '&hidegotoSf=1';
            url += '&toPrestore=1';
          }
          if (this.order.sourceType === 10) {
            url += '&hideContract=1';
          }
  
          // 线上收款
          if (this.accountType == 1) {
            url += '&step=1';
            this.$router.push(url);
          } else {
            // 线下收款
            url += '&step=2';
            this.$router.push(url);
          }
        } else if(ret.code == 830000001) {
          this.$toast.fail(ret.msg);
        }
      }
    },
    toShowStoredCardDetail(item) {
      this.showStoredCardDetailDialog = true;
      this.currentStoredCardDetail = item;
    }
  },
  async created() {
    this.render();
    this.$onBus('refresh-custom-account', this.getAccList.bind(this));
  },
  vxshow() {
    this.getMerchant();
  },
  components: {
    pageFooterBtn,
    customAccount,
    eWalletEditPopup,
    storedCardVerifyPopup,
    // storedCardEditPopup
  },
  watch: {
    allNum: { // 实收总额发生变化
      immediate: true,
      handler: function (nv, ov) {
        if (nv != ov) {
          // 清空电子钱包支付
          this.useWalletPay = false;
          this.useWalletNum = 0;
          // 清空储值卡支付
          this.storedCardAccountList.forEach(v=> {
            this.$set(v, 'isChecked', false);
            this.$set(v, 'money', 0);
          })
        }
      },
    },
  }
};
</script>

<style lang="scss" scoped>
.collect-fee-2 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .main {
    padding-bottom: 20px;
    flex: 1;
    overflow-y: auto;
    .htop {
      margin: calc(var(--gap) * 12) calc(var(--gap) * 16) 0 calc(var(--gap) * 16);
      padding: 0 calc(var(--gap) * 16);
      color: var(--white);
      border-radius: var(--radius-sm);
      // background: var(--white);
      background: linear-gradient(136deg,#18b1ff 0%,#2389ff 100%);
      &.sports {
        background: linear-gradient(136deg, #B2A8FF 0%, #8070F5 100%);
      }
      .ht1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        padding-top: calc(var(--gap) * 12);
        padding-bottom: calc(var(--gap) * 8);
        .ht11 {
          // color: var(--g8);
        }
        .ht12 {
          display: flex;
          align-items: center;
        }
      }
      .ht2 {
        display: flex;
        align-items: center;
        font-size: 22px;
        font-weight: var(--bold);
        padding: 0 calc(var(--gap) * 16);
        // border: 1px solid var(--g3);
        border: 1px solid rgba(var(--g3-rgb), 0.3);
        border-radius: var(--radius-sm);
        overflow: hidden;
        ::v-deep .van-field {
          padding: calc(var(--gap) * 4) calc(var(--gap) * 12) calc(var(--gap) * 4) 0;
          font-size: 36px;
          background: none;
          &.placeh {
            font-size: 22px;
          }
          input {
            height: 42px;
            color: var(--white);
          }
          input::-webkit-input-placeholder {
            // color: var(--g5);
            color: var(--white);
          }
        }
      }
      .ht3 {
        padding: calc(var(--gap) * 8) 0 calc(var(--gap) * 12) 0;
        display: flex;
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
        .ht31 {
          flex: 1;
          // color: var(--g6);
        }
        .ht32 {
          padding-left: calc(var(--gap) * 16);
          flex: 1;
          // color: var(--c3);
        }
      }
    }
    .stp7 {
      .stp71 {
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        // color: var(--g8);
        padding-top: calc(var(--gap) * 26);
      }
      .stp72 {
        font-size: 36px;
        line-height: 42px;
        font-weight: var(--bold);
        padding-top: calc(var(--gap) * 8);
        padding-bottom: calc(var(--gap) * 24);
      }
    }

    .group {
      padding: 0 calc(var(--gap) * 16);
      .ptil {
        padding-top: calc(var(--gap) * 24);
        padding-bottom: calc(var(--gap) * 12);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g6);
        .recommend {
          margin-left: calc(var(--gap) * 2);
          display: inline-block;
          background: #ff4b38;
          color: var(--white);
          line-height: var(--lh-sm);
          font-size: var(--fs-sm);
          padding: 0px calc(var(--gap) * 6);
          border-radius: calc(var(--gap) * 8) calc(var(--gap) * 8) calc(var(--gap) * 8) 0;
        }
        .btns {
          color: var(--c1);
        }
      }
      .pm-wrap {
        background: var(--white);
        border-radius: var(--radius-sm);
        overflow: hidden;
        padding: 0 calc(var(--gap) * 16);
        .pm {
          padding: calc(var(--gap) * 12) 0;
          display: flex;
          .icon {
            margin-right: calc(var(--gap) * 8);
            width: calc(var(--w) * 24);
            height: calc(var(--w) * 24);
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            border-radius: var(--radius-base);

            &.icon1 {
              background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0033.png);
            }
            &.icon2 {
              background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0032.png);
            }
            &.icon3 {
              background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0034.png);
            }
          }
          .r {
            flex: 1;
            .pmc {
              display: flex;
              align-items: center;
              padding-bottom: calc(var(--gap) * 2);
              .tytext {
                flex: 1;
                color: var(--g8);
                font-size: var(--fs-lg);
                line-height: var(--lh-lg);
                font-weight: var(--bold);
                .tag {
                  display: inline-block;
                  vertical-align: text-bottom;
                  border-radius: calc(var(--gap) * 2);
                  margin-left: calc(var(--gap) * 4);
                  padding: 0 calc(var(--gap) * 4);
                  color: var(--white);
                  font-size:var(--fs-sm);
                  line-height:var(--lh-sm);
                  background-color: var(--c1);
                  font-weight: normal;
                  &.is-expire {
                    background-color: var(--g5);
                  }
                }
              }
              .tynum {
                margin-right: calc(var(--gap) * 8);
                color: var(--g8);
                font-size: var(--fs-md);
                line-height: var(--lh-md);
              }
            }
            .desc {
              margin-top: calc(var(--gap) * 2);
              color: var(--g6);
              font-size: var(--fs-md);
              line-height: var(--lh-md);
              display: flex;
              align-items: center;
              .red {
                margin-right: calc(var(--gap) * 2);
                color: var(--c3);
              }
            }
          }
        }
      }
      .pm-empty {
        padding: calc(var(--gap) * 12) 0;
        text-align: center;
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        color: var(--g6);
      }
      .pm-tips {
        margin-top: calc(var(--gap) * 8);
        color: var(--g6);
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
      }
      .tip-wrap {
        padding: calc(var(--gap) * 8) 0;
        .tip {
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--g6);
        }
        .tip-link {
          color: var(--tlc);
          text-decoration: underline;
        }
      }
    }
  }
}

// 有效期右侧样式
.fepl {
  display: flex;
  justify-content: flex-end;
  .ricon {
    padding-top: 2px;
    padding-left: 5px;
  }
}

.student-wallet-detail-dialog {
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    padding: calc(var(--gap) * 16);
}
</style>
